<template>
  <div>
    <ShortlistContext>
      <ShortlistStartup
        v-if="user.isInvestorOrOrganizer"
        :startup="startup"
        :org-id="user.organizationId"
      />
    </ShortlistContext>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ShortlistContext from '@/contexts/ShortlistContext.vue'
import ShortlistStartup from 'components/organizations/ShortlistStartup/ShortlistStartup.vue'

export default {
  components: {
    ShortlistContext,
    ShortlistStartup,
  },
  props: {
    startup: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    toggleFollowTooltipText() {
      return this.startup.follows
        ? 'Click to remove from shortlist'
        : 'Click to add to shortlist'
    },
    ...mapState({
      user: (s) => s.user.data,
    }),
  },
  methods: {
    toggleFollow() {
      const method = this.startup.follows ? 'stopFollowing' : 'startFollowing'
      const action = `startupProfile/${method}`
      this.$store.dispatch(action, { startupId: this.startup.id })
    },
  },
}
</script>
